import * as React from "react";
import {cs} from "../../../../../../../../../react/chain-services";
import "./fields.scss";
import {stateChangeNestedValue} from "../../../../../../../../../react/state-change-nested-value";
import {Select} from "../../../../../../../common/design2/select/select";
import {SubtleBadge} from "../../../../../../../common/design2/subtle-badge/subtle-badge";
import {ErrorHighlighter} from "../../../../../../../../light/error-highlighter";
import {Static2} from "../../../../../../../../../react/static-2";
import {cx} from "emotion";
import {GlobalResizeState} from "../../../../../../../../browser/global-resize-state";
import {scrollIntoView} from "../../../../../../../../light/scroll-into-view";

export const Fields = ({keys, countryCode, columns, next}) => cs(
    ["errorHighlighter", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],
    ["fields", (_, next) => next(getFields({countryCode}))],
    ["conflictedMapping", (_, next) => next((() => {
        const keys1 = Object.keys(keys.value);

        // Conflict mapping
        return keys1.findIndex((k1, i) => {
            for (let j = i+1; j < keys1.length; j++) {
                const k2 = keys1[j];
                if (keys.value[k1] != null && keys.value[k1] !== "" && keys.value[k1] === keys.value[k2]) {
                    return true;
                }
            }
        }) > -1;
    })())],
    ["isSelected", (_, next) => next((apiKey) => {
        const v = keys.value[apiKey];
        return v != null && v !== "";
    })],
    ["invalidRequired", ({fields, isSelected}, next) => next(fields.find((f) => f.required && !isSelected(f.apiKey)))],
    ["viewSize", (_, next) => GlobalResizeState({
        translate: ({width}) => width < 768 ? "sm" : "md",
        next,
    })],

    ({errorHighlighter, domRef, fields, viewSize, invalidRequired, isSelected, conflictedMapping}) => next({
        invalid: conflictedMapping || invalidRequired,
        highlightErrors: () => {
            errorHighlighter.start();
            scrollIntoView(domRef.get());
        },
        render: ({row, showErrors}) => (
            <div className={cx("fields fields-4o2", errorHighlighter.css)} ref={domRef.set}>
                {showErrors && (
                    conflictedMapping ? (
                        <div className="error" xd-qa-type="label" xd-qa-name="Build Address List Conflicted Mappings">
                            You have conflicted mappings
                        </div>
                    ) : invalidRequired && (
                        <div className="error" xd-qa-type="label" xd-qa-name="Build Address List Not Enough Fields">
                            You have not selected enough fields to form a complete address.
                        </div>
                    )
                )}
                {fields.map(({label, apiKey, required}) => {
                    const isIndexUsedByOtherApiKey = (index) => {
                        const keys1 = Object.keys(keys.value);
                        return keys1.findIndex((k1) => index === keys.value[k1] && k1 !== apiKey) > -1;
                    };

                    const hasError = showErrors && (
                        (required && !isSelected(apiKey)) ||
                        (isSelected(apiKey) && isIndexUsedByOtherApiKey(keys.value[apiKey]))
                    );
                    return (
                        <div className="field" key={apiKey}>
                            <div className={cx("label", {required, hasError})} xd-qa-type="label" xd-qa-name={"Build Address List Mapping "+label}>
                                {label}
                            </div>
                            <div className="mapping">
                                {Select({
                                    style: {
                                        height: 25,
                                        fontSize: 13,
                                        color: hasError && "danger",
                                    },
                                    list: [
                                        null,
                                        ...row.map((value, index) => ({
                                            index,
                                            value,
                                        })),
                                    ],
                                    itemToLabel: (e) => e == null ? "Field not needed" : e.value,
                                    itemToInfo: (e) => viewSize !== "sm" && e && SubtleBadge({
                                        message: columns ? columns[e.index] : `Col #${e.index + 1}`,
                                        style: {
                                            color: showErrors && isIndexUsedByOtherApiKey(e.index) && "danger",
                                        }
                                    }),
                                    onChange: (e) => stateChangeNestedValue(keys, [apiKey], () => e?.index),
                                    isSelected: (e) => (
                                        e == null ? (
                                            !isSelected(apiKey)
                                        ) : (
                                            keys.value[apiKey] === e.index
                                        )
                                    ),
                                    autoWidth: viewSize === "sm",
                                    xdQaName: "Build Address List "+label,
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        ),
    }),
);

const getFields = ({countryCode}) => [
    {
        label: "First/Full Name",
        apiKey: "firstname",
        required: true,
    },
    {
        label: "Last Name",
        apiKey: "lastname",
    },
    {
        label: "Company",
        apiKey: "company",
    },
    {
        label: "House #",
        apiKey: "houseNum",
    },
    {
        label: "Address",
        apiKey: "street",
        required: true,
    },
    {
        label: "Apt #",
        apiKey: "aptNum",
    },
    {
        label: "City",
        apiKey: "city",
        required: true,
    },
    {
        label: countryCode === "CA" ? "Province" : "State",
        apiKey: "state",
        required: true,
    },
    {
        label: "Zip Code",
        apiKey: "zip",
        required: true,
    },
];